import React from "react";
import Head from "next/head";

import PropertyDocuments from "components/PropertyDocuments";

import { useFormattedMessage } from "hooks";
import { neuprop04016 } from "i18n/messages/meta";
import { getDocumentsHost } from "common/helper";

const DOCUMENT_HOST = getDocumentsHost();

const DEHH10DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen DE-HH-10",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/DE-HH-10/FINEXITY_neuprop040-16_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2023 - PDF - 224 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* DE-HH-10",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/DE-HH-10/FINEXITY_neuprop040-16_Basisinformationsblatt.pdf`,
        description: "Stand 02/2023 - PDF - 201 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum UPR-SVB",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/DE-HH-10/neuprop040-16_DE-CC-10_Verlaengerung_Angebotszeitraum_UPR-Token.pdf`,
        description: "Stand 01/2024 - PDF - 102 KB",
    },
];

const CDPPDEHH10DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-DE-HH-10",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-10/FINEXITY_neuprop040-16_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2023 - PDF - 225 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-DE-HH-10",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-10/FINEXITY_neuprop040-16_Basisinformationsblatt.pdf`,
        description: "Stand 02/2023 - PDF - 210 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum UPJ-SVB",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-10/neuprop040-16_CD-PP-DE-CC-10_Verlaengerung_Angebotszeitraum_UPJ-Token.pdf`,
        description: "Stand 01/2024 - PDF - 100 KB",
    },
];

const CDPPDEHH11DocumentsData = [
    {
        title: "Schuldverschreibungsbedingungen CD-PP-DE-HH-11",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-11/FINEXITY_neuprop040-16_Schuldverschreibungsbedingungen.pdf`,
        description: "Stand 02/2023 - PDF - 226 KB",
    },
    {
        title: "Basisinformationsblatt (BIB)* CD-PP-DE-HH-11",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-11/FINEXITY_neuprop040-16_Basisinformationsblatt.pdf`,
        description: "Stand 02/2023 - PDF - 208 KB",
    },
    {
        title: "Verlängerung Angebotszeitraum UPS-SVB",
        path: `${DOCUMENT_HOST}/docs/general/neuprop/neuprop040-16/CD-PP-DE-HH-11/neuprop040-16_CD-PP-DE-CC-11_Verlaengerung_Angebotszeitraum_UPS-Token.pdf`,
        description: "Stand 01/2024 - PDF - 99 KB",
    },
];

function Neuprop04016() {
    const { formatMessage } = useFormattedMessage();

    return (
        <>
            <Head>
                <title>{formatMessage(neuprop04016.title)}</title>

                <meta name="description" content="neuprop 040 - 16 GmbH & Co. KG" />
            </Head>
            <div className="broad-container issuer-public-page">
                <section className="banner-section" style={{ backgroundImage: "url(/images/neupropBg.jpg)" }} />
                <section className="content-section small-container">
                    <div className="header-part">
                        <div className="logo-container shadow border-radius">
                            <img src={"/images/logo-neuprop-16.png"} alt="" />
                        </div>
                        <p>
                            Gegenstand der Gesellschaft ist die Verwaltung und Anlage eigenen Vermögens im eigenen Namen und auf
                            eigene Rechnung einschließlich des Erwerbs, der Verwertung, Nutzung, Verwaltung und Veräußerung von
                            Immobilien und der Finanzierung von Immobilienentwicklungsprojekten durch die Vergabe von mehreren
                            Nachrangdarlehen oder auch eines Darlehens ohne qualifizierten Rangrücktritt.
                        </p>
                    </div>
                    <div className="border-x" />
                    <div className="content-part">
                        <h2>neuprop 040 - 16 GmbH & Co. KG</h2>
                        <p>
                            Bei der Finanzierung verfolgt die neuprop 040 - 16 GmbH & Co. KG eine langfristig ausgerichtete
                            Strategie.
                        </p>
                    </div>
                    <div className="two-parts">
                        <div className="first-part">
                            <div className="pdf-part">
                                <h3>Kapitalmarktdokumentation</h3>
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={DEHH10DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPDEHH10DocumentsData} />
                                <PropertyDocuments showTextLength={55} propertyDocumentsData={CDPPDEHH11DocumentsData} />
                                <span className="bottom-line text-14 d-block">
                                    *Basisinformationsblatt gemäß EU-Verordnung 1286/2014
                                </span>
                            </div>
                        </div>
                        <div className="second-part">
                            <h3>Kontakt</h3>
                            <p>
                                Bei Fragen zu den tokenisierten Schuldverschreibungen sind wir persönlich erreichbar über die
                                E-Mail-Adresse:
                                <br />
                                <a href="mailto:neuprop040-16@finexity.com">neuprop040-16@finexity.com</a>
                            </p>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}

export default Neuprop04016;
